import styled from "styled-components";

interface MainTitleProps {
  title: string;
}

const CustomTitle = styled.h1`
  pointer-events: none;
  font-family: "Fascinate Inline", cursive;
  background: -webkit-linear-gradient(#f5e2c8, #d88373);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* Was a flat 4em, which rendered "Argentina" 340px wide and pushed the
     country page into horizontal scroll on a phone. Scales with the viewport
     now, capped at the original desktop size. */
  font-size: clamp(2.1rem, 9vw, 4rem);
  line-height: 1.05;
  overflow-wrap: anywhere;
  flex-wrap: wrap;
`;

export const MainTitle = ({ title }: MainTitleProps) => {
  return <CustomTitle>{title}</CustomTitle>;
};
